import React, { useContext } from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import {
  NavigateConst,
  DeviceTypes,
  useDeviceType,
  toSentancePascalCase,
} from 'common';
import {
  Headings,
  Paragraph,
  Button,
  Link
} from '@sentara-health/optimahealth_web';
import { GlobalContext } from 'context';

interface PaymentSectionProps {
  showPayBill?: boolean;
  onPayBill?: () => void;
}

const PaymentSection: React.FC<PaymentSectionProps> = ({
  showPayBill = false,
  onPayBill,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const deviceType = useDeviceType();
  const { ssoEndPoints } = useContext(GlobalContext);
  const isMobile = deviceType === DeviceTypes.MOBILE;

  const handlePayBill = () => {
    if (onPayBill) {
      onPayBill();
      return;
    }
    navigate(NavigateConst.paySentaraBillURL);
  };

  return (
    <section className="mt-3">
      {showPayBill ? (
        <>
      <Headings
        level={3}
        variant="semiBold"
        text={
          isMobile
            ? toSentancePascalCase(t('medicalClaims.payYourBill'))
            : t('medicalClaims.whatsNext')
        }
        className="mb-3"
      />

        <div className="mb-4">
          {!isMobile ? (
            <Paragraph
              text={t('medicalClaims.payYourBill')}
              variant="bold"
              className="mb-2"
            />
          ) : null}

          <div className="mb-4 m-4">

          <Paragraph
            text={t('medicalClaims.payYourBillContentOne')}
            className="discList m-0"
          />

          <Paragraph
            text={t('medicalClaims.payYourBillContentTwo')}
            className="discList m-0"
            />
            
            </div>

          <div className="d-flex flex-wrap gap-3">
            <Button variant="primary_btn" onClick={handlePayBill}>
              {t('claimsSummary.paySentaraMedicalBill')}
            </Button>
          </div>

          {isMobile ? <hr className="my-4" /> : null}
        </div>
        </>
      ) : null}

      <div className="mt-4">
        {isMobile ? (
          <Headings
            level={3}
            variant="semiBold"
            text={toSentancePascalCase(t('medicalClaims.fileAnAppeal'))}
            className="mb-3"
          />
        ) : (
          <Paragraph
            text={t('medicalClaims.fileAnAppeal')}
            variant="bold"
            className="mb-2"
          />
        )}

        <Paragraph
          level={2}
          text={
            <Trans
              i18nKey="medicalClaims.fileAnAppealContent"
              components={{
                link1: (
                  <Link
                    to={ssoEndPoints?.claimAppealForm}
                    target="_blank"
                    className="text-decoration-underline"
                  />
                ),
              }}
            />
          }
          variant="regular"
        />
      </div>
    </section>
  );
};

export default PaymentSection;